
import tools from "@/common/tool"
import urls from "@/common/urls"
import axios from "@/common/axios"
export const routerBefore = (to, from, next) => {
    let user_id = tools.getStorage("userInfo")?.user_id || 0;
    console.log('user_id :>> ', user_id);
    if (user_id) {
        axios.get(urls.user.login, { "user-id": user_id }).then(() => {
            next()
        }).catch(() => {
            next('/login')
        })
    } else {
        next('/login')
    }
}





